import { render, staticRenderFns } from "./ManagedRuleGroup.vue?vue&type=template&id=0dac32d8"
import script from "./ManagedRuleGroup.vue?vue&type=script&lang=js"
export * from "./ManagedRuleGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports